import { useCallback, useRef } from 'react';
import { ProviderAssignmentAnalyticsEvents } from '~/analytics';
import { CareTeamProviderType } from '~/lib/constants/patients.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

type UseProviderAssignmentAnalyticsProps = {
  inquiryId: string;
  patientId: string;
  providerType: CareTeamProviderType;
};

export type TrackPAEvent = (
  event: ProviderAssignmentAnalyticsEvents,
  props?: Record<string, unknown>,
) => void;

const useProviderAssignmentAnalytics = ({
  inquiryId,
  patientId,
  providerType,
}: UseProviderAssignmentAnalyticsProps): {
  trackPAEvent: TrackPAEvent;
  setPrimaryTag: (tag: string | undefined) => void;
} => {
  const { trackEvent } = useAnalytics();
  const primaryTagRef = useRef<string | undefined>(undefined);

  const setPrimaryTag = useCallback((tag: string | undefined) => {
    primaryTagRef.current = tag;
  }, []);

  const trackPAEvent = useCallback(
    (
      event: ProviderAssignmentAnalyticsEvents,
      props?: Record<string, unknown>,
    ) => {
      trackEvent(event, {
        ...props,
        inquiryId,
        patientId,
        ...(primaryTagRef.current && { primaryTag: primaryTagRef.current }),
        providerType,
      });
    },
    [inquiryId, patientId, providerType, trackEvent],
  );

  return { trackPAEvent, setPrimaryTag };
};

export default useProviderAssignmentAnalytics;
